import React, {Component, useState} from 'react'
import {LayoutHeaderConfig} from 'components/MainLayout'
import {Button, Input, Row, Typography, Skeleton, Form, message, Col, Select} from "antd";
import './Settings.css'
import {
    selectUserProfile
} from "../../store/user/reducer";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {withRouter} from "react-router";
import {fetchMe, fetchUserProfile} from "../../store/user/actions";
import moment from "moment-jalaali"
import {getAuthApi, setAuthToken} from "../../api";
import {ACCESS_TOKEN} from "../../constants";
import momentJaalali from 'moment-jalaali'
import routesConfig from "../../routesConfig";
import CircularDatePicker from "../../components/CircularDatePicker";
const {Title, Paragraph} = Typography;
const { Option } = Select


class Settings extends Component {
    constructor(props) {
        super(props);
        moment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
        this.state = {
            email: '',
            firstName: '',
            lastName: '',
            birthDate: '',
            gender:''
        }}


    componentDidMount() {
        this.props.fetchUserProfile()
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.userProfile === undefined && this.props.userProfile !== undefined){
            this.setState({
                email: this.props.userProfile.email,
                firstName: this.props.userProfile.firstName,
            });
        }
    }

    updateEmail(event) {
        getAuthApi().partaillyUpdateUserProfile({email: this.state.email})
            .then((resp) => message.success("ایمیل با موفقیت تغییر کرد."))
            .catch(error => message.error("تغییر ایمیل با خطا همراه شد!!"));
    }

    changeEmail(event) {
        this.setState({email: event.target.value})
    }

    onChange(event) {
        const varName = event.target.name;
        console.log(varName);
        this.state[varName] = event.target.value;
        this.setState(this.state);
        console.log(this.state)
    }

    onFinish = ({firstName, lastName, birthDate, email,gender}) => {
        // console.log(firstName);
        // onsole.log(lastName);
        // console.log(birthDate);
        // console.log(email);
        let birthDay= ''
        if(birthDate.value!==undefined && birthDate.value!==null) {
            birthDay = birthDate.value;
        } else if(birthDate.length>0) {
           let arr = birthDate.split("-")
           birthDay = arr[0] + '/' + arr[1] + '/' + arr[2];
        }
        const birthDateVal = (birthDate.value!==undefined && birthDate.value.length>0 ) ? momentJaalali(birthDay, 'jYYYY/jM/jD').add(1, 'day'):undefined;
        // console.log(birthDateVal)
        getAuthApi().partaillyUpdateUserProfile({firstName: firstName, lastName: lastName, birthDate: birthDateVal,email: email,gender:gender})
            .then((resp) => message.success("اطلاعات پروفایل با موفقیت تغییر کرد."))
            .catch(error => message.error("ویرایش اطلاعات کاربر با خطا همراه شد!!"));
    }

    onLogout = () =>{
        localStorage.removeItem(ACCESS_TOKEN);
        setAuthToken(null);
        //this.props.fetchMe();
        //this.props.history.push(routesConfig.home);
        window.location = "/";
    }

    render() {
        let initialVals = {}
        if(this.props.userProfile!==undefined){
            console.log(moment(this.props.userProfile.birthDate, 'jYYYY/jM/jD').jYear());
            initialVals = Object.assign({}, this.props.userProfile);
            moment.loadPersian({dialect: 'persian-modern', usePersianDigits: false})
            initialVals.birthDate = moment(this.props.userProfile.birthDate).format('jYYYY-jM-jD');
            moment.loadPersian({dialect: 'persian-modern', usePersianDigits: true})
        }
        return <React.Fragment>
            <LayoutHeaderConfig closeable={true} pageTitle="اطلاعات کاربری" menuEnabled={false} extra={[]}/>
            {
                this.props.userProfile === undefined ?
                    <Skeleton/>
                    :
                    <React.Fragment>
                        <Row justify="" className='px-40'>
                            <Col span={24}><Title level={1} className='f-30 mb-36'> اطلاعات کاربری </Title></Col>
                            <Col span={24}>
                                <Form
                                    className='  mt-0'
                                    layout={"vertical"}
                                    onFinish={this.onFinish}
                                    initialValues={initialVals}
                                >
                                    <Form.Item name={'phoneNumber'} label="شماره تلفن" className="align-right mb-1">
                                        <Input
                                            disabled={true}
                                            placeholder="شماره تلفن"
                                        />
                                    </Form.Item>
                                    <Form.Item name={'nationalId'} label="کد ملی" className="align-right mb-1">
                                        <Input
                                            placeholder={'کد ملی'}
                                            disabled={true}
                                        />
                                    </Form.Item>
                                    <Form.Item name={"firstName"} label="نام" className="align-right mb-1"
                                               rules={[{required: true, message: 'ورود نام اجباری است'}]}>
                                        <Input
                                            placeholder={'نام'}
                                            name={"firstName"}
                                        />
                                    </Form.Item>
                                    <Form.Item name={"lastName"} label="نام خانوادگی" className="align-right mb-1"
                                               rules={[{required: true, message: 'ورود نام خانوادگی اجباری است'}]}>
                                        <Input
                                            placeholder={'نام خانوادگی'}
                                            //value={this.props.userProfile.lastName}
                                        />
                                    </Form.Item>
                                    <Form.Item  name={"birthDate"} label="تاریخ تولد" className="align-right mb-1"
                                                rules={[{required: false}]}>
                                        <CircularDatePicker disabled={false} isBirthDayShow={true}/>
                                        {/*<Input*/}
                                        {/*    placeholder={'تاریخ تولد'}*/}
                                        {/*    // value={moment(this.props.userProfile.birthDate).format('LL')}*/}
                                        {/*/>*/}
                                    </Form.Item>
                                    <Form.Item name={"email"} label="ایمیل" className="align-right mb-1">
                                        <Input
                                            type={"email"}
                                            name={"email"}
                                            placeholder={'ایمیل'}
                                            value={this.state.email}
                                        />
                                    </Form.Item>
                                    <Form.Item name="gender" label="جنسیت"
                                               className='no-red-star f-22 mb-36'>
                                        <Select
                                            placeholder="لطفاً نوع جنسیت را مشخص کنید."
                                            allowClear>
                                            <Option value="MALE">مرد</Option>
                                            <Option value="FEMALE">زن</Option>
                                        </Select>
                                    </Form.Item>
                                    <Form.Item className="align-right ">
                                        <Button
                                            htmlType="submit"
                                            block
                                            type="primary"
                                            shape="round"
                                        > ثبت </Button>
                                    </Form.Item>
                            <Button
                                block
                                type="danger" shape="round"
                                onClick={e => { e.preventDefault(); this.onLogout() }}>
                                خروج از حساب کاربری
                            </Button>
                                </Form>
                            </Col>
                        </Row>

                    </React.Fragment>

            }

        </React.Fragment>
    }
}

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        fetchUserProfile,
        fetchMe,
    },
    dispatch);

const mapStateToProps = state => ({
    userProfile: selectUserProfile(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Settings))